import script from "./control-attribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./control-attribution.vue?vue&type=script&setup=true&lang=ts"

import "./control-attribution.vue?vue&type=style&index=0&id=49f61463&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f61463"]])

export default __exports__